<template>
    <div>
        <div class="u-d-flex u-flex-space-between">
            <div class="flex-grid flex-grid--reduced-bottom-margin flex-state-buttons">
                <div>
                    <form @submit.prevent class="m-form" name="documentEditor">
                        <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
                            <h2 class="u-d-inline-block">Editing - </h2>
                            <control for="claimantName" :table-control="true">
                                <input autocomplete="off" v-model="documentName"
                                        required
                                        placeholder="Document Name"
                                        name="documentName"
                                        id="documentName"
                                        type="text"
                                        class="editing">
                                <control-error :show="documentName===''">
                                    The document name is required
                                </control-error>
                            </control>
                        </div>
                    </form>
                </div>
            </div>
            <div class="flex-grid flex-grid--reduced-bottom-margin u-padding-t-20">
                <router-link :to="this.exitRoute">
                    <svg viewBox="0 0 120 120" class="m-icon m-icon--dark">
                        <use xlink:href="#close"></use>
                    </svg>
                </router-link>
            </div>
        </div>

        <div class="flex-grid a-form-inputs">
            <div class="flex-grid flex-grid--reduced-bottom-margin">
                <router-link v-if="claimType === 'fatal_accident_dependency'"
                             :to="{ name: 'fatal::dependency.documents.list', params : { id: claimId } }"
                             class="a-button a-button--loader-button u-no-margin" tag="button">
                    Back
                </router-link>
                <router-link v-if="claimType === 'fatal_accident_estate'"
                             :to="{ name: 'fatal::estate.documents.list', params : { id: claimId } }"
                             class="a-button a-button--loader-button u-no-margin" tag="button">
                    Back
                </router-link>
                <router-link v-if="claimType === 'lost_years'"
                             :to="{ name: 'lost::documents.list', params : { id: claimId } }"
                             class="a-button a-button--loader-button u-no-margin" tag="button">
                    Back
                </router-link>
                <router-link v-if="claimType === 'personal_injury'"
                             :to="{ name: 'personal::documents.list', params : { id: claimId } }"
                             class="a-button a-button--loader-button u-no-margin" tag="button">
                    Back
                </router-link>
                <button @click="saveDocument()" class="a-button a-button--loader-button u-margin-trbl-0-0-0-10"
                        :disabled="running || documentName ===''" :class="[savingData() ?'a-loader--white':'', documentName ==='' ? 'disabled':'']">
                    <span :class="[savingData() ? 'a-button--span-hidden' : '']">Save</span>
                </button>
                <button @click="saveAndClose()" class="a-button a-button--loader-button u-margin-trbl-0-0-0-10"
                        :disabled="running || documentName ===''" :class="[savingData() ?'a-loader--white':'', documentName ==='' ? 'disabled':'']">
                    <span :class="[savingData() ? 'a-button--span-hidden' : '']">Save &amp; Close</span>
                </button>
                <div class="p-generate-schedule__prompt u-d-none proto-6-a">
                    <div class="p-generate-schedule__prompt-align">Are you sure you want to exit without saving?</div>
                </div>
            </div>
        </div>

        <html-editor :auto-height="false"
                     :height="750"
                     :content="theDocument.html"
                     :z-index="10000"
                     v-if="theDocument.type === 'schedule_of_loss' || theDocument.type === 'offer_letter'"
                     @change="updateContent"
                     class="o-modal--html-editor">
        </html-editor>

        <fatal-dependency-comparison-schedule :index="this.$route.params.document_id"
                                   :document="theDocument"
                                   v-if="theDocument.type == 'comparison_schedule' && claimType === 'fatal_accident_dependency'">
        </fatal-dependency-comparison-schedule>

        <fatal-estate-comparison-schedule :index="this.$route.params.document_id"
                                  :document="theDocument"
                                  v-if="theDocument.type == 'comparison_schedule' && claimType === 'fatal_accident_estate'">
        </fatal-estate-comparison-schedule>

        <lost-comparison-schedule :index="this.$route.params.document_id"
                                  :document="theDocument"
                                  v-if="theDocument.type == 'comparison_schedule' && claimType === 'lost_years'">
        </lost-comparison-schedule>

        <personal-comparison-schedule :index="this.$route.params.document_id"
                                  :document="theDocument"
                                  v-if="theDocument.type == 'comparison_schedule' && claimType === 'personal_injury'">
        </personal-comparison-schedule>

    </div>
</template>

<script>
    import VueHtml5Editor from 'vue-html5-editor';
    import {mapGetters, mapActions} from 'vuex';
    import Vue from 'vue';
    import moment from "moment";
    import fatalIcons from 'components/Icons.vue';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import FatalDependencyComparisonSchedule from 'components/documents/FatalDependencyComparisonSchedule.vue'
    import FatalEstateComparisonSchedule from 'components/documents/FatalEstateComparisonSchedule.vue'
    import lostComparisonSchedule from 'components/documents/LostComparisonSchedule.vue'
    import personalComparisonSchedule from 'components/documents/PersonalComparisonSchedule.vue'
    import FormValidator from 'components/form/validator/mixin';

    export default {
        name: 'editor',
        mixins: [
            FormValidator
        ],
        components: {
            HtmlEditor: new VueHtml5Editor({
              name:"html-editor",
              hiddenModules:[
                'full-screen'
              ],
              visibleModules: [
                "text",
                "color",
                "font",
                "align",
                "list",
                "tabulation",
                "hr",
                "eraser",
                "undo",
              ]
            }),
            FatalDependencyComparisonSchedule,
            FatalEstateComparisonSchedule,
            lostComparisonSchedule,
            personalComparisonSchedule,
            fatalIcons,
            Control,
            ControlError,
        },
        computed: {
            ...mapGetters('documents', {
                findDocument: 'getGeneratedDocument',
                getExitAllowed:'getExitAllowed',
                showingExitNotification:'showingExitNotification'
            }),
            ...mapGetters('claim', {
                claimId: 'id',
                claimType: 'type'
            }),
            ...mapGetters('http', [
                'running',
                'apiRouteRequestRunning'
            ]),
            theDocument() {
                let theDocument = {};
                Vue.util.extend(theDocument, this.findDocument(this.$route.params.document_id));
                return theDocument;
            },
            exitRoute() {
                let params = { id: this.claimId };

                switch(this.claimType) {
                    case 'fatal_accident_dependency':
                        return { name: 'fatal::dependency.documents.list', params };
                    case 'fatal_accident_estate':
                        return { name: 'fatal::estate.documents.list', params };
                    case 'lost_years':
                        return { name: 'lost::documents.list', params };
                    case 'personal_injury':
                        return { name: 'personal::documents.list', params }
                };
            },
            documentName: {
                get() {
                    return this.theDocument.name
                },
                set(value) {
                    this.theDocument.name = value;
                    this.updateDocumentName({value, index: this.$route.params.document_id});
                }
            },
        },
        methods: {
            ...mapActions('documents', {
                saveGeneratedDocument: 'saveGeneratedDocument',
                toggleContent: 'toggleEditingDocument',
                quitEditingDocument: 'quitEditingDocument',
                exitClosed: 'exitClosed',
                exitAttempted: 'exitAttempted',
                updateDocumentName: 'updateDocumentName',
            }),
            updateState() {
                this.updateDocument(this.index, this.theDocument);
            },
            updateContent(content) {
                this.theDocument.html = content;
            },
            saveDocument() {
                this.theDocument.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
                this.saveGeneratedDocument({index: this.index, document: this.theDocument});
            },
            saveAndClose() {
                this.theDocument.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
                this.saveGeneratedDocument({index: this.index, document: this.theDocument}).then(() =>
                    this.$router.push(this.exitRoute)
                )
            },
            savingData() {
                return this.apiRouteRequestRunning('/api/v1/generated-documents/save')
            }

        }
    }
</script>



// WEBPACK FOOTER //
// DocumentEditor.vue?5a562db7